import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import PageTitle from "../../../../jsx/layouts/PageTitle";
// import { Button } from "react-bootstrap";
import { FiEdit } from "react-icons/fi";
import { RiDeleteBinLine } from "react-icons/ri";
import { getAllSportList } from "../../../../services/commonApiService/CommonApiService";
import { UserMenu, DeleteBatch, getBatchById } from "../../../../services/adminApiService/batchManagementApi/BatchManagementApiService";
import { useDeleteHandler } from "../../../../hooks/useDeleteHandler";
import ReactPaginate from "react-paginate";

const ViewBatch = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [userTypeList, setUserTypeList] = useState([]);
    const [userTypeLoading, setUserTypeLoading] = useState(false);
    const [userTypeFilter, setUserTypeFilter] = useState("");
    const [batchDetails, setBatchDetails] = useState({});
    const [athletes, setAthletes] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalAthletes, setTotalAthletes] = useState(0);
    const [allAthletes, setAllAthletes] = useState([]);

    const { handleDelete } = useDeleteHandler();

    const [search, setSearch] = useState("")

    useEffect(() => {
        const fetchUserTypes = async () => {
            try {
                setUserTypeLoading(true);
                const response = await UserMenu();
                setUserTypeList(response?.data?.data || []);
            } catch (error) {
                console.error("Error fetching user types:", error);
            } finally {
                setUserTypeLoading(false);
            }
        };

        fetchUserTypes();
    }, []);


    const deleteHandler = (id) => {
        handleDelete({
            deleteApi: () => DeleteBatch(id),
            refreshListApi: () =>
                navigate("/batch-management/batches"), // Navigate back to batch list after deletion
            successMsg: "Batch deleted successfully"
        });
    };

    const fetchBatchDetails = async () => {
        try {
            const params = {
                user_type: userTypeFilter,
                per_page: perPage,
                search,
                page: currentPage
            };

            const response = await getBatchById(id, params);

            const data = response?.data?.data;
            setBatchDetails(data);
            // setAthletes(data?.athletes || []);
            // setTotalAthletes(data?.pagination?.total || 0);
            setAllAthletes(data?.athletes || []);
            setTotalAthletes(data?.athletes?.length || 0);
        } catch (error) {
            console.error("Error fetching batch details:", error);
        }
    };

    useEffect(() => {
        fetchBatchDetails();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, userTypeFilter, perPage, search, currentPage]);

    const handlePageChange = (event) => {
        setCurrentPage(event.selected + 1);
    };

    const loginDetails = JSON.parse(localStorage.getItem("login_Details"));

    const canEdit = (batchUserLevel) => {
        // If loginDetails is not present, allow edit
        if (!loginDetails) {
            return true;
        }

        // If present, compare user levels
        return loginDetails?.user?.user_level === batchUserLevel;
    };

    useEffect(() => {
        const startIndex = (currentPage - 1) * perPage;
        const endIndex = startIndex + perPage;

        setAthletes(
            allAthletes.slice(startIndex, endIndex)
        );
    }, [allAthletes, currentPage, perPage]);

    return (
        <>

            <PageTitle
                activeMenu="Batch Details"
                motherMenu="Batch Management"
            />

            <h4 className="mb-4 batch-title">Batch Details</h4>

            {/* ================= HEADER CARD ================= */}
            <div className="card p-4 mb-4">

                <div className="d-flex justify-content-between align-items-center mb-3">

                    <button
                        type="button"
                        className="btn back-btn"
                        onClick={() => navigate(-1)}
                    >
                        ← Back
                    </button>

                    <div className="d-flex gap-2">
                        {canEdit(batchDetails?.user_level) ? (
                            <button
                                type="button"
                                className="btn edit-button-view"
                                onClick={() => navigate(`/batch-management/batches/update/${id}`)}
                            >
                                <FiEdit />
                            </button>
                        ) : (
                            <div
                                className="icon_wrapper mx-2"
                                style={{
                                    opacity: 0.2,
                                    cursor: "not-allowed",
                                    pointerEvents: "none",
                                }}
                            >
                                <i className="bi bi-pencil"></i>
                            </div>
                        )}


                        <button type="button" className="text-danger btn edit-button-view" onClick={() => deleteHandler(id)}>
                            <RiDeleteBinLine />
                        </button>
                    </div>
                </div>

                <div className="row">

                    <div className="col-12 col-md-4 mb-3">
                        <label className="text-muted">Batch Name</label>
                        <h6>{batchDetails?.batch_name}</h6>
                    </div>

                    <div className="col-12 col-md-4 mb-3">
                        <label className="text-muted">Sport</label>
                        <h6>{batchDetails?.sport_name}</h6>
                    </div>

                    <div className="col-12 col-md-4 mb-3">
                        <label className="text-muted">Athlete</label>
                        <h6>{batchDetails?.total_athletes} Athletes</h6>
                    </div>

                </div>
            </div>

            {/* ================= ATHLETE TABLE ================= */}
            <div className="card p-4">

                <h5 className="mb-3 batch-title">Athletes</h5>

                {/* Filters */}
                <div className="row g-2 mb-3">

                    <div className="col-12 col-md-6">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search atom id, user name, email..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>

                    <div className="col-6 col-md-3">
                        <select
                            className="form-select"
                            style={{ padding: '0.9rem' }}
                            value={userTypeFilter}
                            onChange={(e) => setUserTypeFilter(e.target.value)}
                        >
                            {userTypeLoading ? (
                                <option>Loading...</option>
                            ) : (
                                <>
                                    <option value="">User Type</option>
                                    {userTypeList?.map((item) => (
                                        <option key={item?.id} value={item?.id}>
                                            {item?.category_name}
                                        </option>
                                    ))}
                                </>
                            )}
                        </select>
                    </div>

                </div>

                {/* Table */}
                <div className="table-responsive">
                    <table className="table">
                        <thead className="bg-primary text-white">
                            <tr>
                                <th>Atom ID</th>
                                <th>User Name</th>
                                <th>Phone</th>
                                <th>Email</th>
                                <th>User Type</th>

                            </tr>
                        </thead>

                        <tbody>
                            {athletes?.length > 0 ? (
                                athletes?.map((athlete) => (
                                    <tr key={athlete?.id}>
                                        <td>{athlete?.atom_id}</td>
                                        <td>{`${athlete?.first_name || ""} ${athlete?.middle_name || ""} ${athlete?.last_name || ""}`}</td>
                                        <td>{athlete?.mobile || "—"}</td>
                                        <td>{athlete?.email}</td>
                                        <td>{athlete?.user_type_name}</td>

                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-center">
                                        No athletes found
                                    </td>
                                </tr>
                            )}
                        </tbody>

                    </table>
                </div>

                {/* Pagination (Static UI) */}
                {/* <div className="d-flex justify-content-between align-items-center mt-3">

                    <div className="d-flex align-items-center gap-2">
                        <select className="form-select" style={{ width: "80px" }}>
                            <option>10</option>
                        </select>
                        <span>Records per page</span>
                    </div>

                    <div>
                        <button className="btn btn-light me-2">Previous</button>
                        <button className="btn btn-light">Next</button>
                    </div>

                </div> */}
                <div className="d-flex justify-content-between align-items-center mt-3">


                    <ReactPaginate
                        nextLabel="next >"
                        onPageChange={handlePageChange}
                        pageRangeDisplayed={5}
                        marginPagesDisplayed={2}
                        pageCount={Math.ceil(allAthletes.length / perPage)}
                        previousLabel="< previous"
                        containerClassName="pagination d-flex flex-wrap"
                        activeClassName="active"
                        pageClassName="page-item mx-1 my-1"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link mx-1 my-1"
                        nextClassName="page-item mx-1 my-1"
                        nextLinkClassName="page-link"
                        breakLabel="..."
                        breakClassName="page-item mx-1 my-1"
                        breakLinkClassName="page-link"
                        forcePage={currentPage - 1}
                    />
                </div>

            </div>


        </>
    );
};

export default ViewBatch;